import { DEFAULT_CONFIG, PROD_CONFIG } from './types';
import type { LabConfig } from './types';

export function buildConfig(mode: 'full' | 'prod', overrides?: Partial<LabConfig>): LabConfig {
  const base: LabConfig = { ...DEFAULT_CONFIG };

  if (mode === 'prod') {
    Object.assign(base, PROD_CONFIG);
  }

  const config: LabConfig = { ...base, ...overrides };
  config.mode = mode;

  // In full mode every feature is enabled and the research cache ladder is used
  // regardless of URL overrides. Tests may still fail individually if the
  // browser does not support them, but they are always attempted.
  if (mode === 'full') {
    config.enableWebGL = true;
    config.enableWebGL2 = true;
    config.enableWASM = true;
    config.enableWorkers = true;
    config.enableNetwork = true;
    config.enableAudio = true;
    config.enableSensors = true;
    config.cacheMode = 'research';
    // Clear any reduced-cache overrides from the URL so the full ladder runs.
    delete config.cacheRuns;
    delete config.cacheWarmup;
    delete config.cacheIterations;
    delete config.cacheSizes;
    delete config.cacheAssociativities;
    delete config.cachePageCounts;
  }

  return config;
}
